/**
 * Config runtime white-label (spec §4). Se il container ha scritto
 * window.__ENV__ (BO_RUNTIME_CONFIG=true) è l'UNICA fonte: niente fallback
 * sui VITE_* compilati nell'immagine (altrimenti un club nuovo userebbe la
 * Firebase di Teramo). Senza __ENV__ (Teramo, dev) → import.meta.env.
 */
export interface RuntimeEnv {
  TENANT_SLUG: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  WS_BASE_URL: string;
  SENTRY_DSN: string;
  APP_DEEPLINK_SCHEME: string;
  PUBLIC_BASE_URL: string;
}

declare global {
  interface Window { __ENV__?: Partial<RuntimeEnv> | null }
}

export function isRuntimeConfig(): boolean {
  return typeof window !== 'undefined' && window.__ENV__ != null;
}

export function env(key: keyof RuntimeEnv): string {
  if (isRuntimeConfig()) return window.__ENV__![key] ?? '';
  return (import.meta.env[`VITE_${key}`] as string | undefined) ?? '';
}
